<template>
  <v-card class="pa-6">
    <BaseDataTable
      :headers="headerTable"
      :items="itemsDespesas"
      :items-per-page="8"
      :loading="loading"
      :paginate="true"
      :currentPage="currentPage"
      :lastPage="lastPage"
      @pageChange="fetchDespesa({ ...filter, page: $event })"
      >
      <template v-slot:top>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="7" lg="7" class="d-flex align-center pa-0">

          </v-col>
          <v-col cols="12" md="5" lg="5" class="d-flex align-start pa-0">
            <v-btn 
              height="55px"
              dark
              class="mr-2 elevation-0"
              color="#313a46"
              @click="openModal()"
            >
              <v-icon small class="mr-3">mdi-plus-circle</v-icon>adicionar
            </v-btn>
            <MenuFilterSearchTable
              :placeholder="'Buscar por razão social ou CNPJ'"
              :textQuery="'nome'"
              :codQuery="'cnpj_completo'"
              @textValue="updateFilter($event)"
            />
          </v-col>
        </v-row>
      </template>
      
      <!-- --------- header --------- -->

      <template v-slot:header.cod_band="{ header }">
        <span>
          {{ header.text }}
          <MenuFilterSelect
            :items="[
              { segmento: '2', descricao: '2 Rodas' },
              { segmento: '4', descricao: '4 Rodas' },
            ]"
            :itemText="'descricao'"
            :itemValue="'segmento'"
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilterSelect>
        </span>
      </template>

      <template v-slot:header.cnpj_completo="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <template v-slot:header.nome="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <template v-slot:header.ativo="{ header }">
        <span>
          {{ header.text }}
          <MenuFilterSelect
            :items="[
              { status: 'Ativo', descricao: 'Ativo' },
              { status: 'Desativado', descricao: 'Desativado' },
            ]"
            :itemText="'descricao'"
            :itemValue="'status'"
            :label="header.text"
            localFilter="api"
            :query="'descricao_ativo'"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilterSelect>
        </span>
      </template>

      <!-- ---------- items ---------- -->
      <template v-slot:item.cod_band="{ item }">
        <BaseSegmento :segmento="item.cod_band" class="d-flex justify-center" />
      </template>
      <template v-slot:item.cnpj_completo="{ item }">{{
        item.cnpj_completo | MaskCnpj
      }}</template>
      <template v-slot:item.nome="{ item }">{{ item.nome }}</template>
      <template v-slot:item.ativo="{ item }">
        <v-chip
          :color="item.ativo ? '#43A047' : '#E53935'"
          class="white--text"
          >{{ item.descricao_ativo | TitleCase }}</v-chip
        >
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn
          v-can:permission="'cnpj-despesa#update'"
          icon
          @click="openModalEdit(item)"
        >
          <v-icon color="warning">mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          v-can:permission="'cnpj-despesa#delete'"
          icon
          @click="deleteDespeda(item)"
        >
          <v-icon color="error">mdi-trash-can</v-icon>
        </v-btn>
      </template>
    </BaseDataTable>
    <!-- <component
      :is="currentComponent"
      :dialog="dialog"
      :labelBtn="labelBtn"
      :itemModal="itemModal"
      @close="destroyAndRecreate($event)"
    />-->
    <ModalCadastro
      :dialog="dialog"
      :labelBtn="labelBtn"
      :itemModal="itemModal"
      @close="closeModal($event)"
    />
  </v-card>
</template>

<script>
import toast from "@/commom/toast";
import BaseSegmento from "@/components/BaseSegmento";
import MenuFilter from "@/components/MenuFilter.vue";
import MenuFilterSearchTable from "@/components/MenuFilterSearchTable.vue";
import MenuFilterSelect from "@/components/MenuFilterSelect.vue";
import DespesaCnpj from "@/services/http/rpa/DespesaCnpj.js";
import { permissions } from "@/store/permissionsStore";
import BaseDataTable from "../../../../components/BaseDataTable.vue";
import ModalCadastro from "./ModalCadastro.vue";

export default {
  components: {
    ModalCadastro,
    MenuFilter,
    MenuFilterSearchTable,
    MenuFilterSelect,
    BaseSegmento,
    BaseDataTable,
  },

  data() {
    return {
      currentComponent: "ModalCadastro",
      dialog: false,
      lastPage: 1,
      currentPage: 1,
      labelBtn: "",
      itemModal: {},
      loading: false,
      itemsDespesas: [],
      filter: {},
      headers: [

      ],
    };
  },

  watch: {
    filter(value) {
      this.fetchDespesa(value);
    },
  },

  computed: {
    headerTable() {
      const permissionUser = permissions();
      let headers = [
        {
          text: "Segmento",
          value: "cod_band",
          align: "center",
        },
        {
          text: "CNPJ",
          value: "cnpj_completo",
        },
        {
          text: "Razão Social",
          value: "nome",
        },
        {
          text: "Status",
          value: "ativo",
          align: "center",
        }
      ];

      if (permissionUser.getPermissions['cnpj-despesa'].includes('delete', 'update')) {
        headers.push({ text: "Ações", align: "center", value: "action" },);
      }
      return headers;
    }
  },

  methods: {
    updateFilter(event) {
      this.filter = { ...this.filter, ...event };
    },

    async fetchDespesa(filters) {
      try {
        this.loading = true;
        let { data } = await DespesaCnpj().show({ ...filters, per_page: 8 });
        this.itemsDespesas = data.data;
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    openModal() {
      this.dialog = true;
      this.labelBtn = "Cadastrar";
    },

    openModalEdit(item) {
      this.dialog = true;
      this.labelBtn = "Editar";
      this.itemModal = item;
    },

    closeModal(event) {
      if (event == "refresh") {
        this.fetchDespesa(this.filter);
      }
      this.dialog = false;
    },

    // destroyAndRecreate(event) {
    //   if (event == "refresh") {
    //     this.fetchDespesa();
    //   }
    //   this.dialog = false;
    //   // Define o componente atual como nulo para destruí-lo
    //   this.currentComponent = null;

    //   // Aguarde algum tempo (opcional)
    //   setTimeout(() => {
    //     // Defina o componente atual como MyComponent para recriá-lo
    //     this.currentComponent = "ModalCadastro";
    //   }, 300); // por exemplo, espere 1 segundo antes de recriar
    // },

    async deleteDespeda(item) {
      let res = await this.$swal({
        title: `Deseja apagar o CNPJ de  ${this.$options.filters.MaskCnpj(
          item.cnpj_completo
        )} da lista ?`,
        text: "Isso não pode ser desfeito",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, apagar CNPJ",
        cancelButtonText: "Cancelar",
      });
      if (!res.isConfirmed) return;
      try {
        await DespesaCnpj(item.id).delete();
        toast("success", "CNPJ removido");
      } catch (err) {
        toast("error", "Erro inesperado");
      } finally {
        this.fetchDespesa(this.filter);
      }
    },
  },

  created() {
    this.fetchDespesa();
  },
};
</script>

<style></style>
